const { FACTURA, BOLETA, NOTA_INGRESO, GUIA_REMISION, NOTA_EGRESO } = require("../../Global");

export const UNDEFINED_DOC = -1;

export const TIPOS_DOCUMENTO_ASOCIADO_SALIDAS = [
    {
        label: "Nota de egreso",
        value: NOTA_EGRESO,
        typeTotal: false,
    }
]

export const TIPOS_DOCUMENTO_ASOCIADO_INGRESOS = [
    {
        label: "Factura Electronica",
        value: FACTURA,
        typeTotal: true,
    },
    {
        label: "Boleta de venta Electronica",
        value: BOLETA,
        typeTotal: true,
    },
    {
        label: "Nota de Ingreso",
        value: NOTA_INGRESO,
        typeTotal: true,
    },
    {
        label: "Guía de remisión - Remitente",
        value: GUIA_REMISION,
        typeTotal: false,
    }
]